import React, { ComponentProps } from "react";
import "react-phone-number-input/style.css";
import Input from "react-phone-number-input/input";
import InputShell, { Props as InputShellProps } from "./InputShell";
import clsx from "clsx";

type Props = {
  onChange: (newValue: string) => void;
  value: string;
} & Omit<InputShellProps, "children"> &
  Omit<ComponentProps<typeof Input>, "onChange" | "label">;

function InputMobile({ label, onChange, value, error, isOptional, ...rest }: Props) {
  const inputShell = {
    label,
    error,
    ...(isOptional
      ? { isOptional, optionalLabel: rest.optionalLabel }
      : { required: rest.required })
  };
  return (
    <InputShell {...inputShell}>
      <Input
        international
        country="PH"
        onChange={onChange}
        value={value}
        withCountryCallingCode
        className={clsx(
          "min-h-[2.5rem] w-full rounded-[0.25rem] border border-outline px-3 text-sm leading-4 focus:outline-none",
          "disabled:bg-slate-100 disabled:text-slate-500"
        )}
        placeholder="+63"
        {...rest}
      />
    </InputShell>
  );
}

export default InputMobile;
